<template>
  <div
    v-if="loaded && showCookieWarning"
    class="flex items-start flex-col sm:flex-row justify-between gap-16 w-full px-16 py-24 sm:p-32 bg-neutral-0 fixed z-[1000] bottom-0 left-0 shadow-[0px_-2px_13px_0px_rgba(0,0,0,0.10)] fixed z-[1000]"
  >
    <div class="sm:max-w-[75%]">
      <h2 class="text-h-l font-bold mb-16">We Use Cookies</h2>
      <p>
        Click “Accept” to enable Us to use cookies to personalize this site, deliver ads, and measure their
        effectiveness on other apps and websites, including social media. Customize your preferences in your Cookie
        Settings or click “Reject” if you do not want us to use cookies for this purpose. Learn more in our
        <a href="/cookie-policy" target="_blank">Cookie Notice</a>.
      </p>
    </div>
    <div class="flex flex-col w-full sm:w-[187px] gap-16 shrink-0">
      <se-button @click="acceptCookies" size="large" class="w-full">Accept</se-button>
      <se-button type="tertiary" @click="disableCookies" size="large" class="w-full">Reject</se-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { rootStore } from '@/src/store/root';
import SeButton from '@/src/ui-kit/button/Button.vue';

const root = rootStore();
const { showCookieWarning } = storeToRefs(root);
const { disableCookies, acceptCookies } = root;

const loaded = ref(false);
onMounted(() => {
  loaded.value = true;
});
</script>

<script lang="ts">
export default {
  name: 'SeCookieWarning',
};
</script>
